import { CdrBreakpointMd } from '@rei/cdr-tokens';

export default {
  data() {
    return {
      slidesVisibles: 2,
    };
  },
  mounted() {
    this.filmstripSlidesVisible();
    window.addEventListener('resize', this.filmstripSlidesVisible);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.filmstripSlidesVisible);
  },
  methods: {
    filmstripSlidesVisible() {
      const matches = (bp) => window?.matchMedia && window?.matchMedia(`(min-width: ${bp}px)`)?.matches;
      this.slidesVisibles = matches(CdrBreakpointMd) ? 3 : 2;
    },
  },
};
